<template>
  <div v-loading="loading" class="sub-task" :class="{ 'full-screen': fullScreen }">
    <div class="title">
      子任务
      <div class="operation-wrap">
        <base-button type="text" class="operation-button" @click="addRow">添加子任务</base-button>
        <base-button type="text" @click="handleFullScreen">
          {{ fullScreen ? "退出全屏" : "全屏" }}
        </base-button>
      </div>
    </div>
    <el-table
      v-ps="'.el-table__body-wrapper'"
      :data="tableData"
      :row-key="getRowKey"
      border
      class="edit-table table-wrap"
      :header-cell-style="{ background: '#f5f7fa' }"
    >
      <el-table-column label="" width="45" align="center">
        <template slot-scope="scope">
          <i
            v-if="!scope.row.data.id"
            class="el-icon-close pointer"
            style="padding: 3px"
            @click="deleteRow(scope.$index)"
          ></i>
        </template>
      </el-table-column>
      <el-table-column
        v-for="column in tableColumns"
        :key="column.prop"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        min-width="180px"
      >
        <template slot="header">
          <div>
            <span v-if="column.required" class="require-flag">*</span>
            {{ column.label }}
          </div>
        </template>
        <template slot-scope="scope">
          <template v-if="column.prop == 'name'">
            <el-input v-model="scope.row.data[column.prop]" placeholder="请填写"></el-input>
          </template>
          <template v-else-if="column.prop == 'status'">
            <el-input :value="scope.row.data[column.prop]" disabled class="color-main"></el-input>
          </template>
          <template v-else-if="column.prop == 'groupId'">
            <el-input :value="taskGroup.name" disabled class="color-main"></el-input>
          </template>
          <template v-else-if="column.prop == 'assignee'">
            <user-selector
              v-model="scope.row.data[column.prop]"
              :project-id="projectId"
              single-value-mode
            ></user-selector>
          </template>
          <template v-else-if="['startAt', 'dueDate'].includes(column.prop)">
            <el-date-picker
              v-model="scope.row.data[column.prop]"
              placeholder="请选择"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </template>
          <template v-else-if="column.prop == 'typeId'">
            <el-select
              v-model="scope.row.data[column.prop]"
              placeholder="请选择任务类型"
              filterable
              :disabled="Boolean(scope.row.data.id)"
              class="color-main"
            >
              <el-option
                v-for="(taskType, index) in taskTypeList"
                :key="index"
                :label="taskType.label"
                :value="taskType.value"
              ></el-option>
            </el-select>
          </template>
          <template v-else-if="column.prop == 'priority'">
            <el-select v-model="scope.row.data[column.prop]" placeholder="请选择">
              <el-option
                v-for="(level, index) in priorityLevel"
                :key="index"
                :label="level.label"
                :value="level.value"
              ></el-option>
            </el-select>
          </template>
          <template v-else-if="column.prop == 'description'">
            <rich-input v-model="scope.row.data.description" type="dropdown"></rich-input>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import RichInput from "@/components/FormControl/RichInput"
import { getTaskTypeListByProject } from "@/api/project/project"
import { priorityLevel } from "~/data/project"
import { subtaskTableColumns as tableColumns } from "./static"
import { randomString } from "@/utils/common"
import UserSelector from "@/components/FormControl/UserSelector"

export default {
  name: "sub-task",
  components: { BaseButton, RichInput, UserSelector },
  props: {
    projectId: String,
    from: {
      type: String,
      default: "create"
    },
    taskGroup: Object
  },
  data() {
    return {
      tableColumns,
      priorityLevel,
      loading: false,
      emptyTask: {
        typeId: "",
        groupId: "",
        name: "",
        assignee: "",
        startAt: "",
        dueDate: "",
        status: "待处理",
        priority: "0",
        description: ""
      },
      tableData: [],
      taskTypeList: [],
      fullScreen: false
    }
  },
  created() {
    this.loading = true
    this.getTaskTypeList().then(() => (this.loading = false))
  },
  methods: {
    init(tasks = []) {
      this.tableData = tasks.map(task => {
        task.priority = task.priority.toString()
        task.description = task.descDetail
        return { data: task, tempId: randomString(10) }
      })
    },
    getRowKey(row) {
      return row.tempId
    },
    getInitData() {
      let newTask = this._.cloneDeep(this.emptyTask)
      newTask.groupId = this.taskGroup.id
      return newTask
    },
    addRow() {
      let newTask = this.getInitData()
      this.tableData.push({ tempId: randomString(10), data: newTask })
    },
    deleteRow(delIndex) {
      this.tableData = this.tableData.filter((val, index) => index != delIndex)
    },
    getTaskTypeList() {
      return getTaskTypeListByProject(this.projectId).then(res => {
        this.taskTypeList = res.map(i => {
          if (!i.taskType) return { label: "默认", value: "", data: i }
          else return { label: i.taskType.name, value: i.taskTypeId, data: i.taskType }
        })
      })
    },
    validate() {
      for (let [index, { data }] of this.tableData.entries()) {
        if (!data.name)
          return { result: false, msg: `子任务表格的第${index + 1}行数据的任务标题未填写！` }
      }
      return { result: true }
    },
    output() {
      let { result, msg } = this.validate()
      if (!result) {
        this.$message.error(msg)
        return { result: false }
      } else {
        return {
          result: true,
          data: this.tableData.map(row => this._.omit(row.data, "children"))
        }
      }
    },
    handleFullScreen() {
      this.fullScreen = !this.fullScreen
      this.$emit("full-screen", this.fullScreen)
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-task {
  &.full-screen {
    width: 100vw !important;
    height: 100vh !important;
    padding: 14px 20px 0 40px !important;
    background-color: #fff;
    .table-wrap {
      height: calc(100vh - 48px - 14px);
      width: 100vw;
      max-width: 100vw;
      margin-left: -40px;
      ::v-deep .el-table__body-wrapper {
        height: calc(100% - 51px);
      }
    }
  }
  .title {
    position: relative;
    margin-bottom: 20px;
    color: $color-font-first;
    font-size: $font-size-title-topic;
    line-height: 28px;
    display: flex;
    &::before {
      content: "";
      position: absolute;
      left: -22px;
      width: 6px;
      height: 28px;
      border-radius: 4px;
      background-color: $color-main;
    }
    .operation-wrap {
      position: absolute;
      right: 0;
    }
  }
  .edit-table {
    ::v-deep {
      tr:hover > td {
        background-color: #ecf5ff;
      }
      .el-table__row {
        td {
          padding: 10px 0;
        }
        .cell {
          min-height: 24px;
          .el-date-editor.el-input {
            width: 100%;
          }
          .color-main .el-input__inner {
            color: $color-font-first;
          }
        }
      }
    }
    .require-flag {
      display: inline-flex;
      vertical-align: middle;
      padding-top: 3px;
    }
  }
}
</style>

<style lang="scss">
.rich-text-popover {
  margin: 0 !important;
  border: none;
}
</style>
